import React from "react";
import classes from "../pages/Post.module.css";

export default function SocialPost({ imgeUrl, title, alt }) {
  return (
    <>
      <div className="m-2">
        <div
          className="card m-1 d-flex flex-column justify-content-between"
          style={{
            maxWidth: "450px",
            height: "550px",
            borderRadius: "5px",
            overflow: "hidden",
            border: "1px solid #ffff",
          }}
        >
          <div className="card-body">
            <div>
              {/* <p className="mb-2">{post.image}</p> */}

              <img src={imgeUrl} alt={alt} className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
